import styled from "styled-components";
export const FormWrap = styled.div`
  width: 100%;
  padding: 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  @media (max-width: 992px) {
    /* display: flex;
    flex-direction: column;
    justify-content: center; */
    min-height: 100vh;
  }
  @media (min-width: 992px) {
    width: 45%;
    margin: 0 auto;
  }
  .rememberForgot {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
    .forgot {
      white-space: nowrap;
      font-size: 16px;
      line-height: 20px;
    }
  }
  .btn-holder {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 15px;
    .textWrapper {
      font-size: 16px;
      line-height: 20px;
      color: #313131;
      @media (min-width: 992px) {
        font-size: 20px;
        line-height: 24px;
      }
      .linkSignup {
        color: ${({ theme }) => theme?.light?.primary};
        border-bottom: 1px solid ${({ theme }) => theme?.light?.primary};
      }
    }
  }
  .signup-fields {
    @media (min-width: 576px) {
      display: flex;
      justify-content: space-between;
      /* align-items: center; */
      gap: 20px;
      .category {
        flex-grow: 1;
      }
      .branches {
        flex-shrink: 0;
        width: 200px;
      }
    }
  }
  .thankyouWrap {
    width: 100%;
    max-width: 487px;
    text-align: center;
    color: var(--text-color);
    margin: 0 auto;
    font-size: 18px;
    line-height: 22px;
    @media (min-width: 992px) {
      font-size: 20px;
      line-height: 24px;
    }
    .imgHolder {
      max-width: 314px;
      height: 292px;
      margin: 0 auto 20px;
      img {
        width: 100%;
        height: auto;
      }
    }
  }
`;
